import React, { useState } from "react";
import { useTabs } from "../../hooks/lib/useTabs";
import { IContactDetailsData } from "../../exports/interfaces";
import { useCompanyDetailsContext } from "../../context/CompanyDetailsContext";
import { stripHtml, truncateText } from "../../exports/functions";
import { useMobile } from "../../hooks/custom/useMobile";
import useTab from "../../hooks/custom/useTab";

export const ContactInfo = ({
  contactDetails,
}: {
  contactDetails: IContactDetailsData[];
}) => {
  useTabs();
  const { companyDetailsData } = useCompanyDetailsContext();
  const isMobile = useMobile();
  const isTab = useTab();
  const [openSidebar, setOpenSidebar] = useState(false);
  return (
    <>
      <section>
        <div className="td_height_120 td_height_lg_40" />
        <div className="container">
          <div
            className="td_section_heading td_style_1 text-center wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.15s"
          >
            <p
              className="td_section_subtitle_up td_fs_18 td_semibold td_spacing_1 td_mb_10 text-uppercase td_accent_color"
              style={{ textAlign: "unset" }}
            >
              CONTACT
            </p>
            <h2 className="td_section_title td_fs_48 mb-0">UNepal Contacts</h2>
            <div className="td_height_30 td_height_lg_30" />
          </div>
          <span
            className="td_fs_18 mb-0"
            dangerouslySetInnerHTML={{
              __html: contactDetails[0]?.description,
            }}
          />

          <div className="td_height_30 td_height_lg_30" />

          <div className="row td_gap_y_50">
            {/* content */}
            <div className="td_course_details">
              {/* tabs */}
              <div className="td_tabs td_style_1 mb-3">
                <ul
                  className="td_tab_links td_style_2 td_type_2 td_mp_0 td_medium td_fs_16 td_heading_color align-items-center justify-content-between"
                  style={{ gap: 0 }}
                >
                  <div className="td_tab_links td_style_2">
                    <li className="active">
                      <a
                        href="#td_tab_1"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="General Inquires"
                      >
                        {truncateText("General Inquires", isMobile ? 10 : 23)}
                      </a>
                    </li>
                    <li
                      style={{
                        cursor: "not-allowed",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{ padding: "10px 20px" }}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Admissions & Academic Information"
                      >
                        {truncateText(
                          "Admissions & Academic Information",
                          isMobile ? 10 : 23,
                        )}
                      </span>
                    </li>
                    {!isMobile && (
                      <>
                        <li
                          style={{
                            cursor: "not-allowed",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{ padding: "10px 20px" }}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Donor Relations & Partnerships"
                          >
                            {truncateText(
                              "Donor Relations & Partnerships",
                              isMobile ? 10 : 23,
                            )}
                          </span>
                        </li>
                        <li
                          style={{
                            cursor: "not-allowed",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{ padding: "10px 20px" }}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Faculty & Staff Opportunities"
                          >
                            {truncateText(
                              "Faculty & Staff Opportunities",
                              isMobile ? 10 : 23,
                            )}
                          </span>
                        </li>
                      </>
                    )}
                  </div>
                  {isMobile && (
                    <li>
                      <div className="course_sidebar_toggle_wrapper">
                        <button
                          className="course_sidebar_toggle mt-1"
                          onClick={() => setOpenSidebar(true)}
                        >
                          <span></span>
                          <span></span>
                          <span></span>
                          {/* <span></span>
                  <span></span>
                  <span></span> */}
                        </button>
                      </div>
                    </li>
                  )}
                </ul>
                <div className="td_tab_body td_fs_18">
                  <div className="td_tab active" id="td_tab_1">
                    <p className="mb-0 custom-text-p">
                      <p>
                        For questions about UNepal’s vision, programs, and
                        general information:
                      </p>

                      <ul className="td_contact_address_widget td_mp_0">
                        <li>
                          <i className="fa-solid fa-phone td_accent_color"></i>
                          <a
                            href={`tel:${companyDetailsData[0]?.telephone_number}`}
                          >
                            {companyDetailsData[0]?.telephone_number}
                          </a>
                        </li>
                        <li>
                          <i className="fa-solid fa-mobile td_accent_color"></i>
                          <a
                            href={`tel:${companyDetailsData[0]?.mobile_number}`}
                          >
                            {companyDetailsData[0]?.mobile_number}
                          </a>
                        </li>
                        <li>
                          <i className="fa-solid fa-envelope td_accent_color"></i>
                          <a href={`mailto:${companyDetailsData[0]?.email}`}>
                            {companyDetailsData[0]?.email}
                          </a>
                        </li>
                        <li>
                          <i className="fa-solid fa-location-dot td_accent_color"></i>
                          <a
                            href={companyDetailsData[0]?.get_direction}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {companyDetailsData[0]?.company_address}
                          </a>
                        </li>
                      </ul>
                    </p>
                  </div>
                  <div className="td_tab" id="td_tab_3">
                    <p className="mb-0"></p>
                  </div>
                </div>
              </div>
              <div>
                <iframe
                  src={stripHtml(companyDetailsData[0]?.map)}
                  width="100%"
                  height="500px"
                  loading="lazy"
                  title="Location"
                  style={{ border: "none" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className={`sidebar_overlay ${openSidebar ? "show_overlay" : ""}`}
        onClick={() => setOpenSidebar(false)}
      />
      <div
        className={`col-lg-3 tabs_wrapper ${openSidebar ? "tabs_open" : ""}`}
      >
        <div className="sidebar_menu">
          {
            <div className="sidebar_mobile_header">
              <button
                className="sidebar_close_btn"
                onClick={() => setOpenSidebar(false)}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
          }
          <h2
            className={`${isMobile || isTab ? "td_fs_36" : "td_fs_48"}`}
            style={
              isMobile || isTab
                ? {
                    width: "90%",
                  }
                : {}
            }
          >
            Contact Tabs
          </h2>

          <div className="sidebar_line" />
          <div className="sidebar_item">
            <div
              className={`sidebar_heading sidebar_active`}
              onClick={() => {
                setOpenSidebar(false);
              }}
            >
              <div className="sidebar_heading_left">
                <h6>General Inquires</h6>
              </div>
            </div>
          </div>
          <div className="sidebar_item">
            <div
              className={`sidebar_heading`}
              onClick={() => {
                // setOpenSidebar(false);
              }}
            >
              <div className="sidebar_heading_left">
                <h6 className="text-secondary">
                  Admissions & Academic Information
                </h6>
              </div>
            </div>
          </div>
          <div className="sidebar_item">
            <div
              className={`sidebar_heading`}
              onClick={() => {
                // setOpenSidebar(false);
              }}
            >
              <div className="sidebar_heading_left">
                <h6 className="text-secondary">
                  Donor Relations & Partnerships
                </h6>
              </div>
            </div>
          </div>
          <div className="sidebar_item">
            <div
              className={`sidebar_heading`}
              onClick={() => {
                // setOpenSidebar(false);
              }}
            >
              <div className="sidebar_heading_left">
                <h6 className="text-secondary">
                  Faculty & Staff Opportunities
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
